import React from "react";
import RefinementList from "components/search/base/RefinementList";
import literaryMovementCategories from "components/search/references/literaryMovementCategories";

const LiteraryMovementRefinementList = () => {
  return (
    <RefinementList
      attribute="literaryMovement"
      categories={literaryMovementCategories}
      limit={100}
      refinementLimit={3}
      title="Literary Movement"
    />
  );
};

export default LiteraryMovementRefinementList;
